// "Do the math" savings table — strongest objection killer for cold ad traffic.
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

const ROWS = [
  { label: "3× Car Wash",                         val: 1800 },
  { label: "2× AC Check-up",                      val: 1400 },
  { label: "3× Car Wash @ ₹299 (save ₹300 each)", val: 900 },
  { label: "2× Cabin Filter Cleaning",            val: 600 },
  { label: "2× Vehicle General Check-up",         val: 1000 },
  { label: "2× Interior + Exterior Shampoo",      val: 1500 },
  { label: "Free Wheel Alignment",                val: 600 },
  { label: "Wheel Alignment 50% Off",             val: 300 },
  { label: "₹500 Off Denting × 2",                val: 1000 },
  { label: "100% Off Labour — General Service",   val: 1800 },
  { label: "50% Off Labour — General Service",    val: 900 },
];

export default function CPSavings({ onBuyClick }) {
  const total = ROWS.reduce((a, r) => a + r.val, 0);
  const saving = total - 1249;

  return (
    <section
      id="savings"
      data-testid="cp-savings"
      className="bg-[#FAFAFA] text-[#0A0A0A] px-5 lg:px-8 py-16 sm:py-24"
    >
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <p className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] font-bold">Do the math</p>
          <h2 className="mt-3 text-3xl sm:text-5xl font-bold tracking-tight">
            Every rupee, accounted for.
          </h2>
          <p className="mt-4 text-base text-[#52525B] max-w-2xl">
            Below is the exact retail price of every service inside Care+.
            Add them up — you get ₹{total.toLocaleString("en-IN")} of value for ₹1,249.
          </p>
        </motion.div>

        <div className="mt-10 bg-white border border-[#E4E4E7] rounded-sm overflow-hidden">
          <div className="grid grid-cols-[1fr_auto] gap-x-4 px-5 py-3.5 bg-[#0A0A0A] text-white text-xs uppercase tracking-wider font-bold">
            <span>Service</span>
            <span>Retail Value</span>
          </div>
          {ROWS.map((r, i) => (
            <div key={i} className="grid grid-cols-[1fr_auto] gap-x-4 px-5 py-3.5 border-b border-[#E4E4E7] last:border-0 text-sm">
              <span className="text-[#27272A]">{r.label}</span>
              <span className="font-bold tabular-nums">₹{r.val.toLocaleString("en-IN")}</span>
            </div>
          ))}
          <div className="grid grid-cols-[1fr_auto] gap-x-4 px-5 py-4 bg-[#FAFAFA] text-base font-bold">
            <span>Total Value</span>
            <span className="tabular-nums">₹{total.toLocaleString("en-IN")}</span>
          </div>
          <div className="grid grid-cols-[1fr_auto] gap-x-4 px-5 py-4 bg-[#D4AF37]/15 text-base">
            <span className="font-bold">You pay just</span>
            <span className="font-extrabold tabular-nums text-[#0A0A0A]">₹1,249</span>
          </div>
          <div className="grid grid-cols-[1fr_auto] gap-x-4 px-5 py-4 bg-[#0A0A0A] text-[#D4AF37] text-base">
            <span className="font-bold uppercase tracking-wider text-xs">You save</span>
            <span className="font-extrabold text-2xl tabular-nums">₹{saving.toLocaleString("en-IN")}</span>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Button
            data-testid="cp-savings-cta"
            onClick={onBuyClick}
            className="bg-[#0A0A0A] hover:bg-black text-white font-extrabold text-base px-8 py-6 rounded-sm"
          >
            Lock in ₹{saving.toLocaleString("en-IN")} savings — Pay ₹1,249 →
          </Button>
        </div>
      </div>
    </section>
  );
}
